import {
    GET_APPLICATIONS_SERVICE_REQUEST,
    GET_APPLICATIONS_SERVICE_SUCCESS,
    GET_APPLICATIONS_SERVICE_FAILURE,
    GET_APPLICATION_BY_ID_SERVICE_REQUEST,
    GET_APPLICATION_BY_ID_SERVICE_SUCCESS,
    GET_APPLICATION_BY_ID_SERVICE_FAILURE,
    UPDATE_APPLICATION_STATUS_SERVICE_REQUEST,
    UPDATE_APPLICATION_STATUS_SERVICE_SUCCESS,
    UPDATE_APPLICATION_STATUS_SERVICE_FAILURE,
    DELETE_APPLICATION_SERVICE_REQUEST,
    DELETE_APPLICATION_SERVICE_SUCCESS,
    DELETE_APPLICATION_SERVICE_FAILURE,
    CREATE_APPLICATION_SERVICE_REQUEST,
    CREATE_APPLICATION_SERVICE_SUCCESS,
    CREATE_APPLICATION_SERVICE_FAILURE,
  } from "./actions";
  
  const initialState = {
    applications: [],
    selectedAnomaly: null,
    loading: false,
    error: null,
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
  };
  
  export default function applicationReducer(state = initialState, action) {
    switch (action.type) {
      // Anomali listesi
      case GET_APPLICATIONS_SERVICE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_APPLICATIONS_SERVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          applications: Array.isArray(action.payload) ? action.payload : [],
        };
      case GET_APPLICATIONS_SERVICE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      // Tek bir anomali getirme
      case GET_APPLICATION_BY_ID_SERVICE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case GET_APPLICATION_BY_ID_SERVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          selectedAnomaly: action.payload,
        };
      case GET_APPLICATION_BY_ID_SERVICE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      // Anomali durumu güncelleme
      case UPDATE_APPLICATION_STATUS_SERVICE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case UPDATE_APPLICATION_STATUS_SERVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          applications: state.applications.map((application) =>
            application.id === action.payload.id
              ? { ...application, status: action.payload.status }
              : application
          ),
        };
      case UPDATE_APPLICATION_STATUS_SERVICE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
    
      // Anomali silme
      case DELETE_APPLICATION_SERVICE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case DELETE_APPLICATION_SERVICE_SUCCESS: {
        // Eğer silinecek uygulama yoksa, aynı referansı döndür
        if (!state.applications.some(app => app.id === action.payload)) {
          return { ...state, loading: false };
        }
        return {
          ...state,
          loading: false,
          applications: state.applications.filter(
            (application) => application.id !== action.payload
          ),
          totalCount: state.totalCount - 1,
        };
      }
      case DELETE_APPLICATION_SERVICE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      case CREATE_APPLICATION_SERVICE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case CREATE_APPLICATION_SERVICE_SUCCESS: {
        // Eğer eklenen uygulama zaten varsa, aynı referansı döndür
        if (state.applications.some(app => app.id === action.payload.id)) {
          return { ...state, loading: false };
        }
        return {
          ...state,
          loading: false,
          applications: [action.payload, ...state.applications],
          totalCount: state.totalCount + 1,
        };
      }
      case CREATE_APPLICATION_SERVICE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
  
      default:
        return state;
    }
  } 